import "./AppLoader.scss"
import {observer} from "mobx-react"
import {apiStatus} from "../../api";

const AppLoader = observer(function AppLoader() {
    return <div className={"app-loader"}>
        {apiStatus.loading && <progress className="progress" max="100"></progress>}
    </div>
})

export {
    AppLoader
}
